import React from 'react';
import EInvoiceAccessLayout from '../../../components/EInvoiceAccessLayout';
import { useRoleModuleLabel } from '../../../hooks/useRoleModuleLabel';
import { READ_PRODUCT } from '../../../constants/eInvoicePermissions';
import { PURCHASE_MODULE_KEY, SALES_MODULE_KEY } from '../../settings/constants/roleModules';

export default function ProductAccessLayout() {
  const salesLabel = useRoleModuleLabel(SALES_MODULE_KEY);
  const purchaseLabel = useRoleModuleLabel(PURCHASE_MODULE_KEY);
  const title = `${salesLabel}/${purchaseLabel}`;

  return <EInvoiceAccessLayout permission={READ_PRODUCT} title={title} />;
}
